<template>
  <div class="inline-flex justify-between w-full md:justify-end items-center">
    <div class="flex flex-col justify-between md:px-8 md:border-r-2 border-gray-300 w-1/2 grow-0 shrink">
      <h5 class="font-semibold text-sm md:text-md dark:text-gray-900">&#8377; {{ itemTotal }} ({{ itemCount }} items)</h5>
      <p class="text-gray-500 text-xs md:text-sm">Extra charges may apply</p>
    </div>
    <div class="px-2 w-1/2 md:w-1/5 grow shrink-0">
      <UButton color="primary" size="xl" label="Go to Cart" class="text-sm" block @click="goToCart" />
    </div>
  </div>
</template>

<script setup>
import { V3PopupComponent } from '#components';
import { V3ModalComponent } from '#components';
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

const { isMobile } = useDevice()
const cart = useCart();
const { gtag } = useGtag();
const auth = useAuth();
  const isAuthenticated = auth && auth.access_token;
  const userData = isAuthenticated ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  } : {
    user_name: null,
    user_phone: null,
    user_email: null
  };
const location = useLocation();
const itemCount = computed(() => cart.itemCount);
const itemTotal = computed(() => cart.itemTotal);
const isLocationAvailable = computed(() => location.isGPSEnabled);

const slideover = useSlideover();

const goToCart = () => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: 'go to cart',
  });

  fbq('track', 'AddToCart', {
    content_name: "Go to cart",
    currency: "INR",
    value: itemTotal.value || 0,
    num_items: itemCount.value || 0,
    ...userData,
  });
  if (!isLocationAvailable) {
    if (isMobile) {
      slideover.open(V3PopupComponent, {
        component: 'location',
        closable: false,
        onSuccess: () => navCart(),
        onClose: slideover.close
      });
    } else {
      modal.open(V3ModalComponent, {
        component: 'location',
        closable: false,
        onSuccess: () => navCart(),
        onClose: modal.close
      });
    }
  } else {
    navigateTo({ path: '/cart' });
  }
};
</script>
